module.exports = __webpack_public_path__ + "img/04.17ad7215.jpg";